import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  pastPerformancesRow: {
    display: "table-row",
    textWrap: "nowrap",
    position: "relative",
    "&.hasClaimedInfo": {
      height: 40
    }
  },
  ppsTableCellWrapper: {
    display: "table-cell",
    padding: "0 6px",
    "&:first-child": {
      paddingLeft: 0
    }
  },
  pastPerformancesCell: {
    display: "flex",
    fontSize: 12,
    padding: 2,
    wordBreak: "break-all"
  },
  comment: {
    fontFamily: "ArialNarrow",
    fontWeight: 400
  },
  pointsInfo: {
    display: "flex",
    padding: "0 8px",
    minWidth: 34
  },
  ellipsis: {
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  jockeyName: {
    maxWidth: 90
  },
  raceType: {
    maxWidth: 125
  },
  temporaryRailDistance: {
    fontSize: "10px",
    marginTop: "-4px"
  },
  integer: {
    fontSize: "10px"
  },
  fracDiagonal: {
    position: "relative",
    display: "inline-block",
    verticalAlign: "middle",
    letterSpacing: "0.001em",
    fontSize: 9,
    bottom: "1px",
    "& > .numerator": {
      position: "relative",
      font: "inherit"
    },
    "& > .bar": {
      position: "relative",
      font: "inherit",
      left: "1px",
      top: "3px"
    },
    "& > .denominator": {
      position: "relative",
      font: "inherit",
      top: "7px"
    }
  },
  fracVertical: {
    position: "relative",
    display: "inline-block",
    verticalAlign: "middle",
    letterSpacing: "0.001em",
    textAlign: "center",
    fontSize: 9,
    margin: "-4px 0",
    "& > .numerator": {
      display: "block",
      borderBottom: "0.001em solid black",
      font: "inherit"
    },
    "& > .bar": {
      display: "none"
    },
    "& > .denominator": {
      display: "block",
      font: "inherit"
    }
  },
  notCompressed: {
    letterSpacing: "normal"
  },
  claimedInfo: {
    position: "absolute",
    left: 0,
    top: 22,
    color: "#e94448",
    letterSpacing: -0.5,
    lineHeight: "14px",
    padding: "0 2px"
  }
});
